module.exports = __webpack_public_path__ + "static/media/I.d7a0f419.jpg";